import { createSlice } from '@reduxjs/toolkit';
import { fetchNotifications } from '../thunks/notificationThunks';

const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    pages: 1
  },
  filters: {
    isRead: 'all', // 'all', 'read', 'unread'
    startDate: null,
    endDate: null
  }
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    markAllAsRead: (state) => {
      state.notifications.forEach(notification => {
        notification.isRead = true;
      });
      state.unreadCount = 0;
    },
    setNotifications: (state, action) => {
      state.notifications.forEach(notification => {
        if (notification?._id === action?.payload)
        notification.isRead = true;
        state.unreadCount -= 1;
      });
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Holidays
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload?.data?.notifications || [];
        state.pagination = action.payload?.data?.pagination || {
          total: 0,
          page: 1,
          limit: 10,
          pages: 1
        }
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  }
});

export const {
  setFilters,
  markAllAsRead,
  setNotifications
} = notificationSlice.actions;

export default notificationSlice.reducer; 